// 관리자 첫 화면의 「결제 전 이용료」 카드 — 이용료 메뉴를 못 찾아도 첫 화면에서 바로 보이게(예행연습 03-2,3)
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getBillingInvoice, koDueDate, type InvoiceView } from "@/lib/billing";

export default function BillingDue() {
  const [inv, setInv] = useState<InvoiceView | null>(null);
  useEffect(() => {
    getBillingInvoice()
      .then((r) => {
        if (r.exempt || !r.invoice) return;
        // 결제 전·확인 중만 띄운다. 계좌이체를 요청한 달은 담당자가 안내 중이라 조용히 둔다
        const due = [r.invoice, ...r.history].find((i) => (i.status === "ready" && !i.transferRequested) || i.status === "confirming");
        setInv(due || null);
      })
      .catch(() => setInv(null));
  }, []);
  if (!inv) return null;
  return (
    <Link to="/admin/billing" className="block card p-4 border border-milk-300 bg-milk-50 hover:bg-milk-100 transition">
      <div className="font-bold text-milk-800">
        💳 {inv.yearMonth} 이용료 {inv.amount.toLocaleString()}원 — {inv.status === "confirming" ? "결제 확인 중" : "결제 전"}
      </div>
      <div className="text-xs text-milk-700 mt-1">
        배송한 학생 {inv.studentCount.toLocaleString()}명 기준입니다.{inv.status === "ready" && inv.dueDate ? ` 결제 기한 ${koDueDate(inv.dueDate)}.` : ""} 자동으로 빠져나가지 않습니다. 눌러서 카드로 내거나 계좌이체를 요청하세요 →
      </div>
    </Link>
  );
}
